import type { ResourceProps } from '@refinedev/core'
import { i18n } from '../../shared/i18n'

export const orderManagementResources: ResourceProps[] = [
  {
    name: 'order-management',
    meta: {
      label: i18n.t('navigation.orderManagement.label'),
    },
  },
  {
    name: 'order-list',
    list: '/orders',
    show: '/orders/:id',
    meta: {
      label: i18n.t('navigation.orderManagement.salesHistory'),
      parent: 'order-management',
    },
  },
]
